import _ from 'lodash';
import api from '../../api';
import { AccountService } from '../../types';

export default {
  findAll(accountId: string): Promise<AccountService[]> {
    return api
      .get(`accounts/${accountId}/services`)
      .then(response => response.data);
  },
  isEnabled(accountId: string, serviceName: string): Promise<boolean> {
    return this
      .findAll(accountId)
      .then((accountServices) => {
        const accountService = accountServices.find(
          as => as.service.name.toLowerCase() === serviceName.toLowerCase(),
        );
        return !_.isUndefined(accountService);
      });
  },
};
